import { render, staticRenderFns } from "./SuppliersGroup.vue?vue&type=template&id=6e807869&scoped=true&"
import script from "./SuppliersGroup.vue?vue&type=script&lang=js&"
export * from "./SuppliersGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e807869",
  null
  
)

export default component.exports